const AUTH_TOKEN_KEYS = ["x-api-key", "token", "authToken"];
const ROLE_KEYS = ["userRole", "role", "userRoles"];

const readFirstNonEmpty = (keys) => {
  for (const key of keys) {
    const value = localStorage.getItem(key);
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }
  return "";
};

export const normalizeRole = (role) =>
  String(role || "")
    .trim()
    .toUpperCase();

export const splitRoles = (rawRoles) =>
  String(rawRoles || "")
    .split(",")
    .map(normalizeRole)
    .filter(Boolean);

export const getStoredRoles = () => {
  const roles = splitRoles(readFirstNonEmpty(ROLE_KEYS));
  return Array.from(new Set(roles));
};

export const getPrimaryRole = () => getStoredRoles()[0] || "";

export const isUserAuthenticated = () => Boolean(readFirstNonEmpty(AUTH_TOKEN_KEYS));

export const hasAllowedRole = (allowedRoles = [], userRoles = getStoredRoles()) => {
  if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
    return true;
  }

  const normalizedAllowedRoles = allowedRoles.map(normalizeRole);
  return userRoles.some((role) => normalizedAllowedRoles.includes(normalizeRole(role)));
};

export const persistAuthSession = (sessionData = {}) => {
  const token = String(
    sessionData.token || sessionData["x-api-key"] || sessionData.authToken || ""
  ).trim();

  const roleValue = Array.isArray(sessionData.role)
    ? sessionData.role.join(",")
    : sessionData.role || sessionData.userRole || sessionData.userRoles || "";
  const role = String(roleValue).trim();

  const schoolId = String(sessionData.schoolId || "").trim();

  if (token) {
    localStorage.setItem("token", token);
    localStorage.setItem("x-api-key", token);
  }

  if (role) {
    localStorage.setItem("role", role);
    localStorage.setItem("userRole", role);
    localStorage.setItem("userRoles", role);
  }

  if (schoolId) {
    localStorage.setItem("schoolId", schoolId);
  }

  if (sessionData.schoolLogo) {
    localStorage.setItem("schoolLogo", sessionData.schoolLogo);
  }

  if (sessionData.schoolName) {
    localStorage.setItem("schoolName", sessionData.schoolName);
  }

  [
    "paymentDueDate",
    "billingStatus",
    "graceDaysRemaining",
    "requiresPayment",
    "messageCreditBalance",
  ].forEach((key) => {
    if (sessionData[key] !== undefined && sessionData[key] !== null) {
      localStorage.setItem(key, String(sessionData[key]));
    }
  });
};

export const clearAuthSession = () => {
  [
    "x-api-key",
    "token",
    "authToken",
    "schoolId",
    "role",
    "userRole",
    "userRoles",
    "paymentDueDate",
    "billingStatus",
    "graceDaysRemaining",
    "requiresPayment",
    "messageCreditBalance",
    "menuData",
    "academicYear",
  ].forEach((key) => localStorage.removeItem(key));
};
